const {PAYMENT_METHODE_TYPE} = require('./PaymentConstant')
const ibanTool = require('ibantools');
const {genHash} = require("../utils/utils");

class DirectDebit {

    constructor({
                    id = genHash(6),
                    accountHolder = '',
                    iban = '',
                    bic = ''

                } = {}) {

        this.id = id;
        this.type = PAYMENT_METHODE_TYPE.DIRECT_DEBIT
        this.accountHolder = accountHolder;
        this._iban = iban;
        this._bic = bic;
    }

    static get PAYMENT_METHODE_TYPE() {
        return PAYMENT_METHODE_TYPE
    };

    static get ibanTool() {
        return ibanTool;
    }

    get iban() {
        return this._iban;
    }

    get friendlyFormatIBAN() {
        return ibanTool.friendlyFormatIBAN(this._iban)
    }

    set iban(value) {
        this._iban = ibanTool.electronicFormatIBAN(value); // Get IBAN in electronic format (no spaces) IBAN validation is not performed
    }

    get bic() {
        return this._bic;
    }

    set bic(value) {
        this._bic = value;
    }

    get isValidIBAN() {
        return ibanTool.isValidIBAN(this._iban)
    }

    get isValidBIC() {
        return ibanTool.isValidBIC(this._bic)
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }


    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                case 'accountHolder':
                    return (typeof this[attribute] === 'string');
                case 'type':
                    return this[attribute] === PAYMENT_METHODE_TYPE.DIRECT_DEBIT;
                case 'iban':
                case '_iban':
                    return ibanTool.isValidIBAN(this[attribute]);
                case 'bic':
                case '_bic':
                    return ibanTool.isValidBIC(this[attribute]);

                default:
                    return false
            }
        } catch (e) {
            console.error('Validating Make with error:', e, attribute);
            return false
        }
    }

    toFirestore() {

        return {
            id: this.id,
            type: this.type,
            accountHolder: this.accountHolder,
            iban: this._iban,
            bic: this._bic,
        }
    }

    static parseFirestore(directDebit) {
        return new DirectDebit(directDebit);
    }
}

module.exports = DirectDebit;